<template>
  <div class="demand-survey">
    <!-- 基础信息与标准类型 -->
    <div class="question-block">
      <div class="sub-question">
        <span>1、您需要编制的标准类型是？</span>
        <el-radio-group v-model="standardType" class="standard-type-group">
          <el-radio-button label="国家标准（GB、GB/T）" class="custom-radio-btn">国家标准（GB、GB/T）</el-radio-button>
          <el-radio-button label="行业标准（如电力、能源行业标准）" class="custom-radio-btn">行业标准（如电力、能源行业标准）</el-radio-button>
          <el-radio-button label="地方标准（D11/XX等）" class="custom-radio-btn">地方标准（D11/XX等）</el-radio-button>
          <el-radio-button label="团体标准（T/CEC等）" class="custom-radio-btn">团体标准（T/CEC等）</el-radio-button>
          <el-radio-button label="企业标准（Q/XXX）" class="custom-radio-btn">企业标准（Q/XXX）</el-radio-button>
          <el-radio-button label="标准化指导性技术文件(GB/Z)" class="custom-radio-btn">标准化指导性技术文件(GB/Z)</el-radio-button>
        </el-radio-group>
      </div>

      <div class="sub-question">
        <span>2、该标准的功能类别属于？</span>
        <el-radio-group v-model="standardFunctionType" class="standard-type-group">
          <el-radio-button label="术语标准（如定义、词汇）" class="custom-radio-btn">术语标准（如定义、词汇）</el-radio-button>
          <el-radio-button label="符号/图形标准（如标识、制图规则）" class="custom-radio-btn">符号/图形标准（如标识、制图规则）</el-radio-button>
          <el-radio-button label="分类标准（如产品/服务等级划分）" class="custom-radio-btn">分类标准（如产品/服务等级划分）</el-radio-button>
          <el-radio-button label="试验方法标准（检测、测量流程）" class="custom-radio-btn">试验方法标准（检测、测量流程）</el-radio-button>
          <el-radio-button label="规范标准（技术要求、性能指标）" class="custom-radio-btn">规范标准（技术要求、性能指标）</el-radio-button>
          <el-radio-button label="规程标准（操作流程、安全规则）" class="custom-radio-btn">规程标准（操作流程、安全规则）</el-radio-button>
          <el-radio-button label="指南标准（推荐性技术指导）" class="custom-radio-btn">指南标准（推荐性技术指导）</el-radio-button>
          <el-radio-button label="评价标准（如质量、能效评级）" class="custom-radio-btn">评价标准（如质量、能效评级）</el-radio-button>
          <el-radio-button label="产品标准（特定产品技术参数）" class="custom-radio-btn">产品标准（特定产品技术参数）</el-radio-button>
          <el-radio-button label="管理体系标准（如ISO 9001）" class="custom-radio-btn">管理体系标准（如ISO 9001）</el-radio-button>
          <el-radio-button label="其他" class="custom-radio-btn">其他</el-radio-button>
        </el-radio-group>
      </div>

      
    </div>

    <!-- 标准化对象与核心内容 -->
    <div class="question-block">
      <!--
      <div class="sub-question">
        <span>4、该标准的主要标准化对象是？</span>
        <el-radio-group v-model="primaryObject" class="standard-type-group">
          <el-radio-button label="产品" class="custom-radio-btn">产品</el-radio-button>
          <el-radio-button label="服务" class="custom-radio-btn">服务</el-radio-button>
          <el-radio-button label="技术/工艺" class="custom-radio-btn">技术/工艺</el-radio-button>
          <el-radio-button label="管理体系" class="custom-radio-btn">管理体系</el-radio-button>
          <el-radio-button label="其他" class="custom-radio-btn">其他</el-radio-button>
        </el-radio-group>
      </div>
      -->

      <div class="sub-question">
        <span>3、请给出标准的主题或拟定名称</span>
        <el-input
          v-model="objectDescription"
          placeholder="请给出标准的主题或拟定名称"
          class="object-input"
          required
        />
      </div>

      <div class="sub-question">
        <span>4、其他需说明的特殊需求？</span>
        <el-input
          type="textarea"
          v-model="specialNeeds"
          placeholder="如产品的核心参数、引言背景介绍等..."
          class="textarea-question"
          rows="4"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'DemandSurvey',
  data() {
    return {
      // 基础信息与标准类型
      standardType: '',
      standardFunctionType: '',

      // 标准化对象与核心内容
      objectDescription: '',
      specialNeeds: ''
    }
  },
  watch: {
    // 监听所有表单数据变化
    standardType: 'updateValidStatus',
    standardFunctionType: 'updateValidStatus',
    objectDescription: 'updateValidStatus',
    specialNeeds: 'updateValidStatus'
  },
  mounted() {
    // 组件加载后立即发送一次验证状态
    this.updateValidStatus();
  },
  methods: {
    /* 组件对外暴露一个方法，用于获取所有问答数据 */
    getSurveyData() {
      return {
        standardType: this.standardType,
        standardFunctionType: this.standardFunctionType,
        objectDescription: this.objectDescription,
        specialNeeds: this.specialNeeds
      }
    },
    
    isSurveyValid() {
      // 检查标准类型是否已选择
      if (!this.standardType) {
        return false;
      }
      
      // 检查标准功能类别是否已选择
      if (!this.standardFunctionType) {
        return false;
      }
      
      // 检查对象描述是否已填写
      if (!this.objectDescription || this.objectDescription.trim() === '') {
        return false;
      }
      
      return true;
    },
    
    /* 更新验证状态并发送事件通知父组件 */
    updateValidStatus() {
      const isValid = this.isSurveyValid();
      this.$emit('validation-change', isValid);
    }
  }
}
</script>

<style scoped>
.demand-survey {
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 20px;
}

.checkbox-column {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.question-block {
  margin-bottom: 30px;
}

.sub-question {
  margin-top: 15px;
}

.sub-question span:first-child {
  display: block;
  margin-top: 10px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.object-input {
  margin-top: 10px;
  width: 100%;
}



.object-input >>> .el-input__inner {
  border-color: #5C3D93;
  border-radius: 6px;
  color: #5C3D93;
  background-color: #E4E0FF;
  font-size: 16px;
}

.object-input >>> .el-input__inner::placeholder {
  color: #5C3D93;
}

.object-input >>> .el-input__inner:hover {
  border-color: #5C3D93;
}

.textarea-question >>> .el-textarea__inner {
  border-color: #5C3D93;
  border-radius: 6px;
  color: #5C3D93;
  background-color: #E4E0FF;
  font-size: 16px;
}

.textarea-question >>> .el-textarea__inner::placeholder {
  color: #5C3D93;
}

.textarea-question >>> .el-textarea__inner:hover {
  border-color: #5C3D93;
}

/* 标准类型单选按钮组样式 */
.standard-type-group.el-radio-group {
  display: grid !important;
  grid-template-columns: repeat(2, 1fr) !important;
  gap: 16px !important;
  margin-top: 16px;
  width: 100%;
  flex-direction: unset !important;
  flex-wrap: unset !important;
}

/* 自定义单选按钮样式 */
.custom-radio-btn {
  position: relative;
  width: 100%;
  margin-right: 0 !important;
}

/* 选中状态样式 */
.custom-radio-btn >>> .el-radio-button__inner {
  padding: 0 16px;
  border: 1px solid #5c5c5c;
  background-color: transparent;
  color: #5c5c5c;
  border-radius: 6px !important;
  height: 39px;
  font-size: 16px;
  font-weight: normal;
  box-shadow: none;
  width: 100%;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 选中状态样式 */
.custom-radio-btn.is-active >>> .el-radio-button__inner {
  background-color: rgba(228, 224, 255, 1);
  border-color: #5c3d93;
  color: #5c3d93;
  box-shadow: none;
  position: relative;
}

/* 选中状态添加图标 */
.custom-radio-btn.is-active >>> .el-radio-button__inner::after {
  content: "";
  position: absolute;
  right: -1px;
  bottom: -1px;
  width: 10px;
  height: 10px;
  background: url("@/assets/images/icon-survey-check.png") no-repeat;
  background-size: cover;
}

/* 移除相邻按钮的边框重叠 */
.custom-radio-btn + .custom-radio-btn >>> .el-radio-button__inner {
  border-left: 1px solid #5c5c5c;
}

/* 当屏幕宽度较大时，使单选按钮水平排列 */
@media (min-width: 768px) {
  .el-radio-group:not(.standard-type-group) {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .el-radio:not(.custom-radio-btn) {
    margin-right: 16px;
    width: calc(50% - 16px);
  }
}

/* 单选按钮样式调整 */
.el-radio-group {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.el-radio {
  margin-bottom: 8px;
  padding: 6px 8px;
  border-radius: 4px;
  transition: all 0.3s;
}

.el-radio:hover {
  background-color: rgba(126, 87, 194, 0.05);
}

/* 对单选按钮内的文本进行样式调整 */
.el-radio__label {
  font-size: 14px;
  color: #333;
}

/* 调整单选按钮选中状态的颜色，与整体主题色调一致 */
.el-radio__input.is-checked .el-radio__inner {
  border-color: #7e57c2;
  background: #7e57c2;
}

.el-radio__input.is-checked + .el-radio__label {
  color: #7e57c2;
}
</style>